import React, { useState, useEffect } from "react";
import PandaLoader from "../PandaLoader";

const FREDOKA = { fontFamily: "'Fredoka', sans-serif" };

const LoadingAnimation = () => {
  const [currentFactIndex, setCurrentFactIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  const [remainingSeconds, setRemainingSeconds] = useState(40);

  const funFacts = [
    "Did you know? Pixley uses AI to bring your avatar to life! ✨",
    "Fun fact: Each avatar is uniquely animated just for you! 🎨",
    "Cool! Our AI learns from millions of animations to make yours special! 🤖",
    "Almost there! Your avatar will be ready to star in stories! 🌟",
    "Magic happening! We're adding personality to your character! 💫",
    "Behind the scenes: AI is painting every detail with care! 🖌️",
  ];

  useEffect(() => {
    const factInterval = setInterval(() => {
      setCurrentFactIndex((prev) => (prev + 1) % funFacts.length);
    }, 5000);
    return () => clearInterval(factInterval);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 95) return prev;
        const increment = Math.max(0.6, (95 - prev) / 24);
        return Math.min(95, prev + increment);
      });
    }, 400);
    return () => clearInterval(progressInterval);
  }, []);

  useEffect(() => {
    const estimated = Math.max(5, Math.round((100 - progress) * 0.4));
    setRemainingSeconds(estimated);
  }, [progress]);

  return (
    <div className="flex flex-col items-center justify-center py-8 px-4 w-full max-w-lg mx-auto">
      <PandaLoader variant="inline" size={180} />

      {/* Progress Bar */}
      <div className="w-full mt-6 mb-6">
        <div className="h-2.5 rounded-full overflow-hidden" style={{ background: 'rgba(11,26,51,0.08)' }}>
          <div
            className="h-full rounded-full transition-all duration-500 ease-out"
            style={{
              width: `${progress}%`,
              background: 'linear-gradient(90deg, #0065F8 0%, #00CAFF 100%)',
            }}
          />
        </div>

        <div className="flex justify-between items-center mt-2.5">
          <span className="text-sm" style={{ ...FREDOKA, color: '#5A6B85' }}>
            {Math.round(progress)}%
          </span>
          <span className="text-sm font-semibold" style={{ ...FREDOKA, color: '#0065F8' }}>
            Animating!
          </span>
        </div>
      </div>

      {/* Fun Fact bubble */}
      <div
        className="w-full px-6 py-5 mb-6"
        style={{
          background: '#FFFFFF',
          border: '2px solid rgba(11,26,51,0.06)',
          borderRadius: 18,
          boxShadow: '0px 2px 0px rgba(11,26,51,0.04)',
        }}
      >
        <p className="text-center text-sm leading-relaxed" style={{ ...FREDOKA, color: '#334155' }}>
          {funFacts[currentFactIndex]}
        </p>
      </div>

      {/* Time estimate */}
      {remainingSeconds > 0 && (
        <p className="text-sm" style={{ ...FREDOKA, color: '#8CA0BC' }}>
          About {remainingSeconds} second{remainingSeconds !== 1 ? "s" : ""} remaining...
        </p>
      )}
    </div>
  );
};

export default LoadingAnimation;
